/* =========================================================
   HOME DECORE — Predictive Search
   ========================================================= */
(function () {
  'use strict';

  var searchDrawer = document.querySelector('[data-search-drawer]');
  if (!searchDrawer) return;

  var input = searchDrawer.querySelector('[data-search-input]');
  var resultsWrap = searchDrawer.querySelector('[data-search-results]');
  var emptyState = searchDrawer.querySelector('[data-search-empty]');
  var initialState = searchDrawer.querySelector('[data-search-initial]');
  var debounceTimer;
  var lastQuery = '';
  var controller;

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function highlightMatch(text, query) {
    var safe = escapeHtml(text);
    if (!query) return safe;
    try {
      var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      return safe.replace(re, '<mark>$1</mark>');
    } catch (e) {
      return safe;
    }
  }

  function renderResults(data, query) {
    if (!resultsWrap) return;
    var resources = data.resources && data.resources.results;
    if (!resources) {
      resultsWrap.innerHTML = '';
      if (emptyState) emptyState.style.display = '';
      return;
    }

    var queries = resources.queries || [];
    var products = resources.products || [];

    if (!queries.length && !products.length) {
      resultsWrap.innerHTML = '';
      if (emptyState) emptyState.style.display = '';
      return;
    }
    if (emptyState) emptyState.style.display = 'none';

    var html = '';

    if (queries.length) {
      html += '<div class="search-suggestion-list">';
      queries.forEach(function (q) {
        html += '<a href="' + q.url + '">' + highlightMatch(q.text, query) + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 18l6-6-6-6"/></svg></a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="search-section-label">Products</div><div class="search-drawer__results-grid">';
      products.forEach(function (p) {
        html += '<a href="' + p.url + '" class="search-result-card">' +
          '<div class="search-result-card__image"><img src="' + (p.featured_image ? p.featured_image.url : '') + '" loading="lazy" width="300" height="375" alt="' + escapeHtml(p.title) + '"></div>' +
          '<p class="search-result-card__title">' + highlightMatch(p.title, query) + '</p>' +
          (p.vendor ? '<p class="search-result-card__vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
          '<p class="search-result-card__price">' + ((window.HomeDecore && window.HomeDecore.formatMoney) ? window.HomeDecore.formatMoney(p.price) : p.price) + '</p>' +
        '</a>';
      });
      html += '</div>';
    }

    resultsWrap.innerHTML = html;
  }

  function performSearch(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(data, query); })
      .catch(function (err) {
        if (err.name !== 'AbortError') console.error(err);
      });
  }

  input && input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      if (resultsWrap) resultsWrap.innerHTML = '';
      if (emptyState) emptyState.style.display = 'none';
      if (initialState) initialState.style.display = query.length === 0 ? '' : 'none';
      return;
    }
    if (initialState) initialState.style.display = 'none';

    debounceTimer = setTimeout(function () {
      if (query === lastQuery) return;
      lastQuery = query;
      performSearch(query);
    }, 250);
  });

  searchDrawer.addEventListener('overlay:open', function () {
    setTimeout(function () { input && input.focus(); }, 100);
  });
})();
